
import { message } from 'antd';
import { vendorPreview, vendorCommit } from '../services/api';

function init() {
  return {
    currentStep: 0
  };
}

export default {
  namespace: 'register',

  state: init(),
  effects: {
    *getPreviewData({ payload }, { call, put }) {
      const res = yield call(vendorPreview);
      if (!res) return;
      if (res.success) {
        yield put({
          type: 'getPreviewDataSuccess',
          payload: {
            data: res.data || payload
          }
        });
      } else {
        res.msg && message.error(res.msg);
      }
    },
    *commitVendor({ payload }, { call, put }) {
      const { props, randomCode } = payload;
      const res = yield call(vendorCommit, randomCode);
      if (res.success) {
        props.history.push('/register/finished');
      } else {
        res.msg && message.error(res.msg);
        yield put({
          type: 'updateState',
          payload: {
            data: {
              randomCodeQuery: Date.now(),
            }
          }
        });
      }
    },
  },
  reducers: {
    updateState(state, { payload: { data } }) {
      return {
        ...state,
        ...data
      };
    },
    getPreviewDataSuccess(state, { payload: { data } }) {
      return {
        ...state,
        previewData: data
      };
    },
    clear() {
      return init();
    }
  }
};
